/** Design System — Typography tokens (SLDS scale, Salesforce Sans). */

export const fontFamily = {
  sans: '"Salesforce Sans", Inter, "Segoe UI", Roboto, Arial, sans-serif',
  mono: '"JetBrains Mono", "SFMono-Regular", Menlo, Consolas, monospace',
} as const;

/** Font-size scale in px (product-owner specified). */
export const fontSize = {
  caption: 12,
  table: 13,
  body: 14,
  h4: 18,
  h3: 20,
  h2: 24,
  h1: 32,
  display: 36,
} as const;

export const fontWeight = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
} as const;

export const lineHeight = {
  tight: 1.4,
  normal: 1.5,
  relaxed: 1.6,
} as const;

export const letterSpacing = {
  tight: '-0.01em',
  normal: '0',
  wide: '0.02em',
} as const;

export interface Typography {
  readonly fontFamily: typeof fontFamily;
  readonly fontSize: typeof fontSize;
  readonly fontWeight: typeof fontWeight;
  readonly lineHeight: typeof lineHeight;
  readonly letterSpacing: typeof letterSpacing;
}

export const typography: Typography = {
  fontFamily,
  fontSize,
  fontWeight,
  lineHeight,
  letterSpacing,
};
